import React from 'react';
import { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Flashbar,
  FlashbarProps,
  Link,
} from '@amzn/awsui-components-console';
import { v4 } from 'uuid';

// Slack channel for TLC support (same channel referenced by the Slackbox help footer).
const TCX_CONFERENCES_SLACK_URL =
  'https://amzn-aws.slack.com/archives/G01B6BT0NF8';

interface advanceErrorHandlingProps {
  status?: number;
  errorMsg: string;
}

export const AdvanceErrorHandlingPage = ({
  status,
  errorMsg,
}: advanceErrorHandlingProps) => {
  const [items, setItems] = useState<FlashbarProps.MessageDefinition[]>([]);

  useEffect(() => {
    const id = v4();

    let content: React.ReactNode;
    if (status === 403 || errorMsg?.includes('explicit deny')) {
      content = (
        <>
          Either you do not have permissions to perform this action, or your
          browser token is expired. Try refreshing the page or clearing your
          cache/cookies, and if that doesn&apos;t work, reach out for help in
          the{' '}
          <Link target='_blank' href={TCX_CONFERENCES_SLACK_URL}>
            #tcx-conferences Slack channel
          </Link>
          .
        </>
      );
    } else if (errorMsg) {
      content = errorMsg;
    } else {
      content =
        'Page cannot be found, there may be a connectivity issue, please try again later';
    }

    const errorItem: FlashbarProps.MessageDefinition = {
      dismissible: true,
      dismissLabel: 'Dismiss message',
      id,
      loading: false,
      type: 'error',
      header: `error: ${status ? status : 'unknown'}`,
      content,
      action: (
        <Button variant='normal' href='#/'>
          Home page
        </Button>
      ),
      onDismiss: () => {
        setItems((prev) => prev.filter((item) => item.id !== id));
      },
    };

    setItems([errorItem]);
  }, [status, errorMsg]);

  return (
    <div>
      <Flashbar items={items} />
    </div>
  );
};

export default AdvanceErrorHandlingPage;
